import { render } from "./newStockAllocation.vue?vue&type=template&id=04ec02ec"
import script from "./newStockAllocation.vue?vue&type=script&lang=js"
export * from "./newStockAllocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__